import React from "react";

export function InnCheckbox(props) {
  const handlechange = (e) => {
    //console.log(e.target.checked);
    if (props.onChecked != undefined) props.onChecked(e.target.checked,e);
  };

  return (
    <div
      className={"form-group" + " " + props.className}
      onChange={props.onClick}
      id={props.id}
    >
      <label
        className={
          props.disabled == true
            ? "general-checkbox disabled"
            : "general-checkbox"
        }
      >
        <p>{props.children}</p>
        <input
          type="checkbox"
          checked={props.checked}
          disabled={props.disabled}
          onChange={handlechange}
          id={props.id}
        />
        <span className="checkmark"></span>
      </label>
    </div>
  );
}

//click event and checked event raise
